import Vue from "vue"
import Vuex from "vuex"
import axios from "axios"
import { router } from "./router"

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        web_url: "https://www.ramjournal.org",
        base_url: "https://www.api.1sepetkayisi.aslanyazilimm.com/AslanApi/",
        img_base_url: "https://www.img.1sepetkayisi.aslanyazilimm.com/superAdminImg/",
        img_upload_url: "https://www.img.1sepetkayisi.aslanyazilimm.com/UploadImg/superadmin_upload_img.php",
        token: "",
        id: "",
        loginResult: false
    },
    mutations: {
        setToken(state, getdata) {
            state.id = getdata.id
            state.token = getdata.token

        },
        clearToken(state) {
            state.id = ""
            state.token = ""
        }
    },


    actions: {
        login({ commit, dispatch, state }, data) {
            let dataUrl = "https://www.api.1sepetkayisi.aslanyazilimm.com/AslanApi/SuperAdmin/superAdminLogin.php?key=123"

            var datas = {
                email: data.email,
                password: data.password

            };



            return axios.post(dataUrl, JSON.stringify(datas),

            ).then(response => {
                console.log(response.data.data[0].super_token)


                if (response.data.data) {

                    this.state.loginResult = true;

                    var senddata = {
                        id: response.data.data[0].id,
                        token: response.data.data[0].token
                    }


                    commit("setToken", senddata)

                    localStorage.setItem("id", response.data.data[0].id)
                    localStorage.setItem("token", response.data.data[0].super_token)

                } else {
                    //conso.log("hatalı giriş");
                }

            }).catch(err => {
                //conso.log(err.response);
            });


        },

        logout({ commit }) {

            commit("clearToken")

            localStorage.removeItem("id")
            localStorage.removeItem("token")
            location.reload();
        }

    },

    getters: {
        isLogin(state) {

            return localStorage.getItem("id") !== null && localStorage.getItem("token") !== null
        },
        getUser(state) {

            var result = {
                id: state.id,
                token: state.token
            }

            return result
        }
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store.js